// extracted by mini-css-extract-plugin
export default {"list_item":"CategoryList_list_item__gB3HK","container":"CategoryList_container__yv8R1"};